export enum SurveyFrequency {
  "once" = "once",
  "weekly" = "weekly",
  "bi-weekly" = "bi-weekly",
  "monthly" = "monthly",
  "quarterly" = "quarterly",
}

export enum QuestionType {
  FREE_TEXT = "free-text",
  STAR_RATING = "star-rating",
  THUMB_RATING = "thumb-rating",
  LIKERT_SCALE = "likert-scale",
  SELECT = "select",
  MULTI_SELECT = "multi-select",
}

export interface Question {
  questionId?: string;
  questionType: QuestionType;
  questionText: string;
  mandatory: boolean;
  options?: Array<{ label: string; value: string | number | boolean }>;
}

export function assertQuestion(data: unknown): data is Question {
  try {
    return (data as Question) !== undefined;
  } catch {
    return false;
  }
}

export interface SurveyRequest {
  surveyName: string;
  startDate: string;
  frequency: SurveyFrequency;
  endDate?: string;
  questions: Question[];
}

export interface FormValidationError {
  [key: string]: string;
}
